import { useImageSource } from "pages/components/CameraDisplayer";
import React from "react";

export default function ImageZoom({
  zoomData,
  zoomImageFeature,
  zoomImageRate,
  zoomCenterCoordinateX,
  zoomCenterCoordinateY,
  imageProps,
}) {
  const { imageSrc } = useImageSource(imageProps);
  return (
    <div
      className="base-page-camera-card-displayer-zoom-wrapper"
      style={{
        height: zoomData.size.height || "unset",
        minHeight: zoomData.size.height || "200px",
        width: zoomData.size.width || "100%",
        backgroundColor: zoomImageFeature ? "#555" : "white",
        marginBottom: 24,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          style={{
            position: "absolute",
            width: (zoomData.size.width * zoomImageRate) / 100,
            height: (zoomData.size.height * zoomImageRate) / 100,
            top:
              zoomData.size.height / 2 -
              (((zoomData.size.height * zoomImageRate) / 100) *
                (100 - zoomCenterCoordinateY)) /
                100,
            left:
              zoomData.size.width / 2 -
              (((zoomData.size.width * zoomImageRate) / 100) *
                zoomCenterCoordinateX) /
                100,
          }}
          alt=""
        />
      ) : (
        <div style={{ color: "#999", fontSize: 14 }}>
          画像が利用できません
        </div>
      )}
    </div>
  );
}
